module.exports = __webpack_public_path__ + "static/media/dreamBox.12735bd1.gif";